export default __webpack_public_path__ + "static/media/about.61529df9.md";